import { Card } from "@/shared/components/ui/card";
import { cn } from "@/shared/libs/utils";

interface Props {
    label: string;
    value: number;
    valueClassName?: string;
}

export function InfoCountCard({ label, value, valueClassName }: Props) {
    return (
        <Card className="w-[200px] h-[100px] flex flex-col items-center justify-center gap-2">
            <div className="text-[20px] font-bold">{label}</div>
            <div className={cn("text-[17px] font-bold", valueClassName)}>{value}</div>
        </Card>
    );
}